import React from 'react';
import styles from './HeroVideo.module.css';

const HeroVideo = () => {
    return (
        <div className={styles.heroVideo}>
            <video
                aria-label="Golden Stage"
                playsInline
                preload="auto"
                muted
                loop
                autoPlay
                src="https://video.wixstatic.com/video/11062b_fb3c7a9262a443bcaeb3141615a6d2ff/720p/mp4/file.mp4"
                className={styles.video}
            ></video>
        </div>
    );
};

export default HeroVideo;